import * as React from 'react';

function IconKey({ ...props }) {
    return (
        <svg
            viewBox="0 0 64 64"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M60.21,29.22l-5.87-3.39c-.13-.03-.25-.07-.38-.1h-27.24c-1.67-4.35-5.88-7.45-10.82-7.45-6.4,0-11.6,5.19-11.6,11.6s5.19,11.6,11.6,11.6c4.94,0,9.15-3.09,10.82-7.45h3.2s.06-.01.09-.04l2.12-2.46c.13-.15.36-.15.49,0l2.12,2.46s.05.04.09.04h1.08s.07-.02.09-.05l1.56-2.33c.13-.2.42-.2.55,0l1.35,2.02c.05.07.15.07.19,0l.84-1.46c.15-.25.51-.25.66,0l1.02,1.77s.06.06.1.06h2.3s.08-.02.1-.06l.99-1.72c.16-.28.56-.28.72,0l.99,1.72s.06.06.1.06h1.32s.08-.02.1-.06l1.29-2.24c.12-.22.44-.22.56,0l1.29,2.24s.06.06.1.06h1.82c.13-.03.25-.07.38-.1l5.87-3.39c.51-.29.51-1.03,0-1.32ZM11.9,33.64c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76Z" />
        </svg>
    );
}
IconKey.propTypes = {};

export default IconKey;
